var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.displayLabel)?_c('div',{staticClass:"bold-text"},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.withTime)?_c('div',{staticClass:"mt-2"},[_vm._v("\n    "+_vm._s(_vm.getValueWithTime(_vm.property))+"\n  ")]):_c('div',[_vm._v("\n    "+_vm._s(_vm.getValue(_vm.property))+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ba6fe36","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/b122/showFields/ShowDateField.vue
// module id = ICeQ
// module chunks = 0